import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  parseStringToDatepickerDate(dateString: string): Date {
    return new Date(dateString);
  }
  
  public generateAvatarUrl(seed: string): string {
    const baseUrl = "https://api.dicebear.com/9.x/thumbs/svg";
    const url = new URL(baseUrl);
    url.searchParams.set("seed", seed);

    // Randomly select one of the background colors
    const backgroundColors = ["b6e3f4", "c0aede", "d1d4f9"];
    const randomColor = backgroundColors[Math.floor(Math.random() * backgroundColors.length)];
    url.searchParams.set("backgroundColor", randomColor);

    return url.toString();
  }

  // Function to provide a human-readable file size
  public humanFileSize(bytes: number): string {
    if (bytes === 0) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return (bytes / Math.pow(k, i)).toFixed(2) + ' ' + sizes[i];
  }

  // Function to convert a date string to a Date object
  formatDateToString(date: Date): string {
    const safeDate = this.toSafeDate(date);
    if (!safeDate) {
      console.warn('Invalid date provided:', date);
      return '';
    }

    // Format the date to YYYY-MM-DD
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  // Function to safely convert a date string to a Date object
  toSafeDate(input: any): Date | null {
    const date = input instanceof Date ? input : new Date(input);
    return isNaN(date.getTime()) ? null : date;
  }
}
